export class ClaimResultModel {
  constructor(successIn: boolean, msgIn: string) {
    this.success = successIn;
    this.msg = msgIn;
  }
  public id: number;
  public success: boolean;
  public msg: string;
}

export class ClaimFinalizationModel {
  constructor(pIdIn: number, passwordIn: string, recaptchaIn: any) {
    this.pId = pIdIn;
    this.password = passwordIn;
    this.recaptcha = recaptchaIn;
  }
  public pId: number;
  public password: string;
  public recaptcha: any;
}
